import React from 'react'
import styles from './UIGamePortraitTop.module.scss'
import {UIGameHelpUserSettingsButtonContainer} from '../UIGameHelpButtons/UIGameHelpButtons'
import {UIGameEndReturnToStats} from '../UIGameEnd/UIGameEndReturnToStats/UIGameEndReturnToStats'
import {UIGameBank} from '../UIGameBank'
import {UIGameTimerContainer} from '../UIGameTimer/UIGameTimerContainer'
import {UIGameEndShareReplay} from '../UIGameEnd/UIGameEndShareReplay/UIGameEndShareReplay'
import {ModeSettingEnum} from '@colonist/types'
import {useIsReplay} from '../../store/selectors/useIsReplay'
import {useGameStore} from '../../store/GameStoreContext'
import clsx from 'clsx'

interface UIGamePortraitTopProps {
    initialCanResign: boolean
    className?: string
}

export const UIGamePortraitTop = ({
    initialCanResign,
    className,
}: UIGamePortraitTopProps) => {
    const isReplay = useIsReplay()
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P

    return <div className={clsx(styles.topContainerPortrait, className)}>
        {isReplay === false && <div className={styles.gameHelpUserSettingsButtonContainer}>
            <UIGameHelpUserSettingsButtonContainer
                initialCanResign={initialCanResign}
                isGameInfoOptionVisible={true}
                isRulesOptionVisible={true} />
        </div>}
        {isReplay && <div className={styles.gameEndReturnToStatsContainer}>
            <UIGameEndReturnToStats text="strings:game.endGame.cornerButton.openStatsMobile" className={styles.gameEndReturnToStatsButton} />
        </div>}

        <div className={styles.gameBankContainer}>
            <UIGameBank isLandscape={false} />
        </div>
        {isReplay === false && isBeginnerMode === false && <div className={styles.gameTimerContainer}>
            <UIGameTimerContainer timerStyle='white' />
        </div>}
        {isReplay && <div className={styles.gameEndShareReplayContainer}>
            <UIGameEndShareReplay />
        </div>}
    </div>
}
